export default "__VITE_ASSET__CyPggwm3__"